import { render, staticRenderFns } from "./IconParagraph.vue?vue&type=template&id=5fc1d051"
import script from "./IconParagraph.vue?vue&type=script&lang=js"
export * from "./IconParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports